/* error-screen-parts.tsx generated by @compiled/babel-plugin v0.36.1 */
/* eslint-disable @atlaskit/ui-styling-standard/enforce-style-prop */
import "./error-screen-parts.compiled.css";
import * as React from 'react';
import { ax, ix } from "@compiled/react/runtime";
import { forwardRef } from 'react';
import { useIntl } from 'react-intl-next';
import Button from '@atlaskit/button/new';
import WarningIcon from '@atlaskit/icon/core/migration/warning';
import { Text } from '@atlaskit/primitives/compiled';
import { AI_MODAL_SCREEN_CLASS } from '../../../utils/constants';
import { FloatingContainer } from '../../components/FloatingContainer/FloatingContainer';
import { Breakpoint } from '../../hooks/useElementBreakpoints';
import messages from './messages';
var buttonContainerStyles = null;

// eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage
var divWrapperContainerStyleUnbounded = null;
var divWrapperContainerStyle = null;
var smallBreakPointAlignItems = null;
var errorFloatingContainerStyle = null;
var smallErrorFloatingContainerStyle = null;

// eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage
var spanWrapperStyleUnbounded = null;
var spanWrapperStyle = null;
var smallBreakPointTop = null;
export function ErrorMessage(_ref) {
  var children = _ref.children,
    breakpoint = _ref.breakpoint;
  var _useIntl = useIntl(),
    formatMessage = _useIntl.formatMessage;
  return /*#__PURE__*/React.createElement("div", {
    className: ax(["_16jlkb7n _1o9zkb7n _i0dlf1ug _1e0c1txw _2lx2vrvc _1bah1y6m _4cvr1h6o", "_zulp19bv", breakpoint <= Breakpoint.Small && "_4cvr1y6m"])
  }, /*#__PURE__*/React.createElement("span", {
    className: ax(["_1e0c116y _4cvr1h6o _1bah1h6o _kqswh2mm _1o9zidpf _154ize3t", "_vwz4kb7n", breakpoint <= Breakpoint.Small && "_154i1i6y"])
  }, /*#__PURE__*/React.createElement(WarningIcon, {
    label: formatMessage(messages.warningIconLabel),
    color: "var(--ds-icon-warning, #E56910)"
  })), /*#__PURE__*/React.createElement(Text, {
    as: "p"
  }, children));
}
export function ErrorButton(_ref2) {
  var children = _ref2.children,
    onClick = _ref2.onClick,
    appearance = _ref2.appearance,
    testId = _ref2.testId,
    autoFocus = _ref2.autoFocus,
    _ref2$disabled = _ref2.disabled,
    disabled = _ref2$disabled === void 0 ? false : _ref2$disabled;
  return /*#__PURE__*/React.createElement(Button, {
    autoFocus: autoFocus,
    testId: testId,
    spacing: "compact",
    onClick: onClick,
    type: "button",
    appearance: appearance,
    isDisabled: disabled
  }, children);
}
export function ErrorButtonContainer(_ref3) {
  var children = _ref3.children;
  return /*#__PURE__*/React.createElement("div", {
    className: ax(["_zulpu2gc _1e0c1txw _1n261g80 _2lx2vrvc _1bahesu3 _4cvr1h6o"])
  }, children);
}

// Need to use forwardRef because functional component cannot be passed a ref
// as a prop.
export var ErrorFloatingContainer = /*#__PURE__*/forwardRef(function (_ref4, ref) {
  var children = _ref4.children,
    breakpoint = _ref4.breakpoint;
  return /*#__PURE__*/React.createElement(FloatingContainer, {
    ref: ref,
    "data-testid": "error-screen"
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
    ,
    className: ax(["_zulpu2gc _1e0c1txw _2lx2vrvc", breakpoint <= Breakpoint.Small && "_zulppxbi _1e0c1txw _2lx21bp4", "error-screen ".concat(AI_MODAL_SCREEN_CLASS)]),
    paddingAdjustments: {
      top: 1,
      bottom: 1
    },
    rainbowBorder: false
  }, children);
});